import { render, staticRenderFns } from "./AdminChat.vue?vue&type=template&id=c1423146"
import script from "./AdminChat.vue?vue&type=script&lang=js"
export * from "./AdminChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports